export default __webpack_public_path__ + "static/media/Ballroll_00371.b983e0f7.png";